import { render, staticRenderFns } from "./PricesPage.vue?vue&type=template&id=b54fbf2a&"
import script from "./PricesPage.vue?vue&type=script&lang=js&"
export * from "./PricesPage.vue?vue&type=script&lang=js&"
import style0 from "./PricesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports